import { useEffect } from "react";
import Wallet from "./Wallet";
import TxHash from "./TxHash";
import UserBalances from "./UserBalances";
import { AppState } from "../../types/types";
import Price from "./Price";
import RotatingLogos from "../RotatingLogos";

interface AsidePanelProps {
  appState: AppState;
  balanceRefresh: number;
  setBalanceRefresh: React.Dispatch<React.SetStateAction<number>>;
  setAccountKitUser: React.Dispatch<React.SetStateAction<string | null>>;
  setAppState: React.Dispatch<React.SetStateAction<AppState>>;
}

const AsidePanel: React.FC<AsidePanelProps> = ({
  appState,
  balanceRefresh,
  setBalanceRefresh,
  setAccountKitUser,
  setAppState,
}) => {
  // Trigger a balance refresh on initial mount
  useEffect(() => {
    setBalanceRefresh((prev) => prev + 1);
  }, [setBalanceRefresh]);

  // Trigger a balance refresh whenever the userAddress changes
  useEffect(() => {
    if (appState.userAddress) {
      setBalanceRefresh((prev) => prev + 1);
    }
  }, [appState.userAddress, setBalanceRefresh]);

  return (
    <aside
      className={
        "relative " +
        "w-full sm:w-11/12 md:w-5/12 lg:w-1/4 xl:w-2/5 " +
        "bg-secondary-dark text-white p-4 md:h-full min-h-screen " +
        "flex flex-col gap-4 text-xs mt-2 sm:mt-0 " +
        "pb-16 sm:pb-20 md:pb-24 xl:pb-28 h-auto"
      }
    >
      <h2 className="text-3xl md:text-4xl font-bold text-center text-primary-dark">
        Dashboard
      </h2>
      <div className="flex flex-col gap-2 transition-opacity duration-300 animate-fade-in">
        <Wallet
          setUserAddress={setAccountKitUser}
          setBalanceRefresh={setBalanceRefresh}
        />

        <Price />

        <TxHash
          txStatus={appState.txStatus}
          txHash={appState.txHash}
          userAddress={appState.userAddress}
        />
        <UserBalances
          userAddress={appState.userAddress ?? ""}
          amountNAU={appState.amountNAU}
          refresh={balanceRefresh}
          onBalanceUpdate={(newBal) =>
            setAppState((prev) => ({ ...prev, balance: newBal }))
          }
          network="base"
        />
      </div>

      {!appState.userAddress && (
        <div className="absolute bottom-2 md:bottom-50 left-1/2 z-50 -translate-x-1/2">
          <RotatingLogos />
        </div>
      )}
    </aside>
  );
};

export default AsidePanel;
